export default {
  "ID": "เลขประจำตัว",
  "acccidentInsurance": "เอกสารประกันอุบัติเหตุ",
  "addManpowerBTN": "เพิ่มรายชื่อ",
  "addManpowerModal": "เพิ่มรายชื่อผู้ปฏิบัติงาน",
  "additionalInformation": "ข้อมูลเพิ่มเติม (ถ้ามี)",
  "address": "ที่อยู่",
  "all": "ทั้งหมด",
  "announce": "Announce",
  "announcement": "Announcement",
  "announcementAttachment": "Announcement Attachment",
  "applicantBearer": "Applicant / Bearer",
  "applicantNo": "หมายเลขประจำตัว Applicant",
  "applicationForContractorAccessCard": "เอกสารขอทำบัตรสำหรับผู้รับเหมา",
  "applicationFormForSpecialCase": "เอกสารแนบเฉพาะผู้ที่เข้าเงื่อนไขพิเศษ",
  "appoint": "Appoint",
  "approvalBySectionHead": "อนุมัติโดย Section Head",
  "approvalHistory": "ประวัติการอนุมัติ",
  "approvalResult": "ผลการอนุมัติ",
  "approvalType": "ประเภท",
  "approve": "อนุมัติ",
  "approved": "อนุมัติ",
  "approvedSucceeded": " อนุมัติ/ผ่าน",
  "approver": "ผู้อนุมัติ",
  "approverPosition": "ฝ่ายอนุมัติ",
  "assignWorkerToContract": "สร้างผู้ปฏิบัติงานใหม่",
  "assignedContract": "สัญญาที่ทำงานอยู่",
  "attention": "โปรดทราบ",
  "bachelorDegre": "ปริญญาตรี",
  "basicInfo": "ข้อมูลทั่วไป",
  "basicTraining": "ใบรับรองการอบรม",
  "basicTrainingCertificate": "เอกสารรับรองการอบรมขั้นพื้นฐาน",
  "basicTrainingCertificateRemark": "* กดเมื่อทำการอบรมเรียบร้อยแล้ว หรือไม่กดหากต้องการนัดวันอบรม",
  "bearerNo": "หมายเลขประจำตัว Bearer",
  "bigTruck": "รถบรรทุกใหญ่",
  "birthdate": "วัน เดือน ปีเกิด",
  "browse": " เลือกไฟล์",
  "canAccessRestrictedArea": "การขออนุญาตเข้าพื้นที่",
  "cancel": "ยกเลิก",
  "cancelChange": "ยกเลิกแก้ไขข้อมูล",
  "cancelExtend": "ยกเลิกขอขยายบัตร",
  "cancellationReason": "เหตุผลการยกเลิกขอขยายบัตร",
  "cancelReasonExtension": "ยกเลิกการขอขยายวันสิ้นสุดบัตรผู้รับเหมา",
  "cancelRenew": "ยกเลิกต่ออายุ",
  "carTypeBigTruck": "รถบรรทุกใหญ่",
  "carTypeCrane": "รถเครน/เฮี๊ยบ",
  "carTypeFireTruck": "รถดับเพลิง",
  "carTypeManagementCar": "รถผู้บริหาร ",
  "carTypeOilTruck": "รถบรรทุกน้ำมัน",
  "carTypeOther": "อื่นๆ",
  "carTypePickUp": "รถบรรทุกเล็ก",
  "carTypeVan": "รถตู้",
  "cardApproval": "การอนุมัติบัตร",
  "cardNo": "เลขที่บัตร",
  "cardPrinting": "พิมพ์บัตร",
  "certificateNumber": "เลขทะเบียนวุฒิบัตร",
  "certificateOfBasicFireAndEvcuation": "เอกสารรับรองการอบรมดับเพลิงและหนีไฟขั้นต้น",
  "certificateOfFirstName/LastNameChange": "เอกสารหลักฐานการเปลี่ยนชื่อหรือนามสกุล",
  "certificateOfFlagman": "เอกสารรับรองการอบรม Flagman ของกลุ่มไทยออยล์",
  "certifiedHealthCheck": "ใบตรวจสุขภาพ",
  "changeCard": "แก้ไขข้อมูล",
  "changeSticker": "แก้ไขข้อมูล",
  "checkUpDate": "วันที่ตรวจ",
  "chooseWorkerForManpowerList": "เลือกผู้ปฏิบัติงานจากรายการผู้ปฏิบัติงาน",
  "citizenDuplicateBody": " พบผู้ปฏิบัติงานคนนี้ในสัญญาอื่น กรุณายืนยันการดำเนินการต่อ ",
  "citizenDuplicateHeader": "ผู้ปฏิบัติงานอยู่ในสัญญาอื่น",
  "citizenID": "เลขประจำตัวประชาชน",
  "citizenIDCopy": "สำเนาบัตรประจำตัวประชาชน",
  "citizenIDPassportNumber": "เลขประจำตัวประชาชน/เลขที่หนังสือเดินทาง",
  "city": "อำเภอ/เขต",
  "completeTrainingStatus": "อบรมแล้ว",
  "confinedSpace": "งานในที่อับอากาศ",
  "confinedSpaceAuthorizer": "ผู้อนุญาตทำงานในที่อับอากาศ",
  "confinedSpaceCertificateAttachment": "เอกสารรับรองการอบรม",
  "confinedSpaceSupervisor": "ผู้ควบคุมงานในที่อับอากาศ",
  "confinedSpaceWorker": "ผู้ปฏิบัติงานในที่อับอากาศ",
  "confirm": "ยืนยัน",
  "confirmDeletion": "ยืนยันการลบ",
  "consentToDisclosePersonalData": "เอกสารยินยอมเปิดเผยข้อมูล",
  "contactAddress": "ที่อยู่ที่สามารถติดต่อได้",
  "contactUs": " ติดต่อเรา ",
  "contractCoOrdinatorName": "เจ้าหน้าที่แผนกงานสัญญา",
  "contractHasNoCustodian": "สัญญานี้ไม่มีผู้ควบคุมงานหรือเจ้าหน้าที่จัดซื้อจัดจ้าง ทำให้ไม่สามารถเพิ่มรายชื่อได้ โปรดติดต่อเจ้าหน้าที่สัญญา",
  "contractList": "รายการสัญญา",
  "contractName": "ชื่อสัญญา",
  "contractNo": "เลขที่สัญญา",
  "contractStatus": "สถานะสัญญา",
  "contractorCompany": "บริษัทผู้รับเหมา",
  "contractorName": "ชื่อผู้รับเหมา",
  "contractorSupervisor": "หัวหน้างานผู้รับเหมา",
  "crane": "รถเครน/เฮี๊ยบ",
  "craneExpiredDateOfCertified": "วันที่ใบอนุญาตหมดอายุ",
  "craneMedicalCertificateAttachment": "เอกสารตรวจสุขภาพผู้ควบคุมปั้นจั่น",
  "craneOperator": "ผู้บังคับปั้นจั่น",
  "craneRigger": "ผู้ยึดเกาะวัสดุ (ผูกรัด)",
  "craneRole": "ตำแหน่งหน้าที่ปฏิบัติงาน",
  "craneSignalMan": "ผู้ให้สัญญาณแก่ผู้บังคับปั้นจั่น",
  "craneSupervisor": "ผู้ควบคุมการใช้ปั้นจั่น",
  "createWorker": "เพิ่มผู้ปฏิบัติงาน",
  "criticalTitle": "คำเตือน",
  "criticality": "ระดับความสำคัญของสัญญา",
  "custodianName": "ผู้ควบคุมงาน",
  "custodianSection": "แผนกของผู้ควบคุมงาน",
  "cvOrResumeOrCertificateFromContractorCompany": "เอกสารรับรองการปฏิบัติงานจากบริษัทผู้รับเหมา",
  "dateOfBirth": "วัน เดือน ปีเกิด",
  "dateOfCertified": "วันที่ได้รับอนุญาต",
  "dateOfCertifiedHealthCheck": "วันที่ตรวจสุขภาพ",
  "dateOfTraining": "วันที่เริ่มต้นการอบรม",
  "dateTime": "วันที่และเวลา",
  "degree": "วุฒิการศึกษา",
  "deletionMessage": "คุณต้องการลบ \"{$PH}\" ใช่หรือไม่",
  "district": "ตำบล/แขวง",
  "doctoralDegrees": "ปริญญาเอก",
  "document": "ตรวจสอบเอกสาร",
  "documentIssueDate": "วันที่ออกเอกสาร",
  "downloadTemplateBtn": "Download Template",
  "driverLicense": "ใบอนุญาตขับรถ",
  "driverLicenseAttachment": "สำเนาใบขับขี่",
  "driverType": "ประเภทรถ",
  "dropFileHere": "วางไฟล์ที่นี่",
  "elearning": " เรียนออนไลน์ ",
  "email": "อีเมล",
  "endDate": "วันที่สิ้นสุดสัญญา",
  "err0000Message": "โปรดลองอีกครั้ง หรือติดต่อผู้ดูแลระบบ",
  "errorAgreeText": "ตกลง",
  "errorMessageAtlest": "โปรดระบุอย่างน้อย {$PH}",
  "errorMessageAtmost": "โปรดระบุอย่างมาก {$PH}",
  "errorMessageBetween": "โปรดระบุระหว่าง {$PH} - {$PH_1}",
  "errorMessageCharacter": "อักขระ",
  "errorMessageCharacters": "อักขระ",
  "errorMessageDigit": "หลัก",
  "errorMessageDigits": "หลัก",
  "errorMessageEmail": "อีเมลไม่ถูกต้อง",
  "errorMessageEnglishChar": "ตัวอักษรภาษาอังกฤษ",
  "errorMessageEqualTo": " โปรดระบุเท่ากับ {$PH}",
  "errorMessageMinLength": "โปรดระบุอย่างน้อย {$PH} ตัวอักษร",
  "errorMessageNum": "ตัวเลข",
  "errorMessageOr": "หรือ",
  "errorMessagePrefix": "โปรดระบุเพียง",
  "errorMessageRequired": "โปรดระบุข้อมูลให้ครบถ้วน",
  "errorMessageSameTo": "โปรดระบุให้เหมือน {$PH}",
  "errorMessageSpecialChar": "อักขระพิเศษ",
  "errorMessageThaiChar": "ตัวอักษรภาษาไทย",
  "errorTitle": "ระบบขัดข้อง",
  "ever": "เคย",
  "exampleDocument": "ตัวอย่างเอกสาร",
  "expWithThaioil": "เคยมีประสบการณ์ทำงานในไทยออยล์",
  "expireDate": "วันที่หมดอายุ",
  "expiredDateOfCertified": "วันที่หมดอายุการปฏิบัติหน้าที่",
  "expiredDateOfDriverLicense": "วันที่ใบขับขี่หมดอายุ",
  "expiredDateOfHealthCheck": "วันหมดอายุ",
  "expiredDateOfWorkPermit": "วันที่หมดอายุ",
  "extendCard": "ต่ออายุบัตร",
  "extendSticker": "ต่ออายุสติกเกอร์",
  "extensionContractorCard": "ขยายวันสิ้นสุดบัตรผู้รับเหมา",
  "extensionReason": "เหตุผลการขอขยายบัตร",
  "failTraining": "ไม่ผ่านอบรม",
  "fireTruck": "รถดับเพลิง",
  "fireWatch": "ผู้เฝ้าระวังเพลิงไหม้",
  "fireWatchManTrainingCertificateAttachment": "เอกสารรับรองการอบรม Fire Watch Man ของไทยออยล์",
  "fitToWork": "ปฏิบัติงานได้",
  "flagman": "ผู้ให้สัญญาณการจราจร",
  "forkLift": "คนขับรถยก",
  "forklift": "คนขับรถยก",
  "forkliftDriver": "ผู้ขับรถยก",
  "forkliftDriverCertificateAttachment": "เอกสารรับรองการอบรม",
  "forkliftDriverFormAttachment": "เอกสารขออนุญาตขับรถ",
  "formTOPAttachment": "เอกสารขออนุญาตสอบขับรถในโรงกลั่น",
  "fullName": "ชื่อ-นามสกุล",
  "fullNameEN": "ชื่อ-นามสกุล (อังกฤษ)",
  "fullNameTH": "ชื่อ-นามสกุล (ไทย)",
  "gender": "เพศ",
  "highPressureWaterJet": "ผู้ฉีดล้างด้วยน้ำแรงดันสูง",
  "highPressureWaterJetCertificateAttachment": "เอกสารรับรองการอบรม",
  "highPressureWaterJetTrainingRequestAttachment": "เอกสารแจ้งขออบรม High Pressure Water Jet",
  "highSchool": "มัธยมศึกษาตอนปลาย",
  "holeWatch": "ผู้ช่วยเหลือในที่อับอากาศ",
  "idenNo": "หมายเลขประจำตัว TOP Group Contractor Safety Trainer",
  "inProcess": " อยู่ระหว่างดำเนินการ",
  "infoTitle": "แจ้งเพื่อทราบ",
  "interview": "สัมภาษณ์",
  "items": "รายการ",
  "issuedCard": "ออกบัตรเรียบร้อยแล้ว",
  "lastNameEN": "นามสกุล (อังกฤษ)",
  "lastNameTH": "นามสกุล (ไทย)",
  "lastname": "นามสกุล",
  "lastname_EN": "นามสกุล EN",
  "lastname_TH": "นามสกุล TH",
  "logout": " ออกจากระบบ ",
  "managementCar": "รถผู้บริหาร",
  "manpowerList": "รายชื่อผู้ปฏิบัติงาน",
  "masterDegrees": "ปริญญาโท",
  "medicalCenterName": "ชื่อโรงพยาบาล",
  "medicalCertificate": "ใบรับรองแพทย์หรือเอกสารยืนยันการตรวจสุขภาพประจำปี และแบบฟอร์มจาก TOP I-COVID ",
  "medicalCertificateAttachment": "เอกสารใบตรวจสุขภาพ",
  "medicalLicenceNo": "ใบอนุญาตประกอบวิชาชีพเวชกรรมโรคศิลป์ เลขที่",
  "name": "ชื่อ",
  "nameEN": "ชื่อ (อังกฤษ)",
  "nameOfInstructor": "ชื่อและนามสกุลวิทยากรอบรม",
  "nameTH": "ชื่อ (ไทย)",
  "name_EN": "ชื่อ EN",
  "name_TH": "ชื่อ TH",
  "nationality": "สัญชาติ",
  "newCard": "ขอบัตรใหม่",
  "newExpiryDate": "วันที่สิ้นสุดใหม่",
  "newSticker": "ทำสติกเกอร์ใหม่",
  "no": "ไม่ใช่",
  "notEver": "ไม่เคย",
  "fail": "ไม่ผ่าน",
  "failed": "ไม่ผ่าน",
  "oilTruck": "รถบรรทุกน้ำมัน",
  "ok": "ตกลง",
  "onlyActiveContracts": "Only Active Contracts",
  "or": "หรือ",
  "order": "ลำดับที่",
  "other": "อื่นๆ",
  "otherNationality": "ระบุสัญชาติ {$INTERPOLATION}",
  "succeed": "ผ่าน",
  "passport": "เลขที่หนังสือเดินทาง",
  "passportAddress": "ที่อยู่ตามหนังสือเดินทาง",
  "passportCopy": "สำเนาหนังสือเดินทาง",
  "paymentCertificateAttachment": "เอกสารรับรองการชำระเงิน",
  "pending": "รอส่งอนุมัติ",
  "phoneNumber": "เบอร์โทรศัพท์",
  "photoRecomend": "รูปภาพของผู้ปฏิบัติงาน (รองรับสกุลไฟล์ JPG)",
  "physicianName": "ชื่อแพทย์",
  "pickUp": "รถบรรทุกเล็ก",
  "plant": "พื้นที่ปฏิบัติงาน",
  "position": "ตำแหน่ง",
  "positionLevel": "ระดับตำเเหน่ง",
  "postalCode": "รหัสไปรษณีย์",
  "primarySchool": "ประถมศึกษา",
  "print": "พิมพ์บัตร",
  "printSticker": "พิมพ์สติกเกอร์",
  "printed": "พิมพ์บัตรแล้ว",
  "printedSticker": "พิมพ์สติกเกอร์แล้ว",
  "privacyPolicy": " ประกาศความเป็นส่วนตัวสำหรับซัพพลายเออร์และคู่ค้าธุรกิจ ",
  "process": "ขั้นตอนดำเนินการ",
  "processStep": "ขั้นตอน",
  "province": "จังหวัด",
  "reason": "เหตุผล",
  "reasonOf": " เหตุผลที่ {$INTERPOLATION} ",
  "reasonRejected": "เหตุผลการไม่อนุมัติ/ไม่ผ่าน",
  "reassign": "มอบหมาย",
  "reassignHistory": "ประวัติมอบหมาย",
  "refresh": "อบรมซ่อม",
  "reject": "ไม่อนุมัติ",
  "rejectReasonRequired": "ระบุเหตุผล",
  "rejected": "ไม่อนุมัติ",
  "rejectedApproval": "ไม่อนุมัติ",
  "rejectedDocument": "ไม่อนุมัติเอกสาร",
  "rejectedInterview": "ไม่ผ่านสัมภาษณ์",
  "rejectedFailed": " ไม่อนุมัติ/ไม่ผ่าน",
  "remarks": "หมายเหตุ",
  "renew": "ต่ออายุ",
  "requestChange": "ขอแก้ไขข้อมูล",
  "requestChangeEndDate": "ขออนุมัติเปลี่ยนวันสิ้นสุดบัตร",
  "requestExtend": "ขอขยายบัตร",
  "requestExtension": "ขอขยายบัตร",
  "requestExtensionExpiryOfContractorCard": "ขอขยายวันสิ้นสุดบัตรผู้รับเหมา",
  "requestForRefreshTrainingForCurrentYear": "ส่งคำขออบรม Refresh applicant/Bearer ประจำปี",
  "requestedForTrainTheTrainerCourse": "ส่งคำขอเพื่อที่จะปฏิบัติหน้าที่ train the trainer",
  "resultApproval": "ผลการอนุมัติ",
  "safety": "เจ้าหน้าที่ความปลอดภัยในการทำงาน",
  "safetyAuthorizer": "หลักสูตร",
  "safetyCertificateAttachment": "เอกสารรับรองการอบรม",
  "safetyofficerAtManagementCourse": "เจ้าหน้าที่ความปลอดภัยระดับบริหาร",
  "safetyofficerAtProfessionalCourse": "เจ้าหน้าที่ความปลอดภัยระดับวิชาชีพ",
  "safetyofficerAtSupervisorCourse": "เจ้าหน้าที่ความปลอดภัยระดับหัวหน้างาน",
  "safetyofficerAtTheAdvanceTechnicalCourse": "เจ้าหน้าที่ความปลอดภัยระดับเทคนิคขั้นสูง",
  "safetyofficerAtTheTechnicalCourse": "เจ้าหน้าที่ความปลอดภัยระดับเทคนิค",
  "save": "บันทึก",
  "secondarySchool": "มัธยมศึกษาตอนต้น",
  "section": "สังกัด (แผนก)",
  "selectSpecialWorkType": "เลือกประเภทหน้าที่เฉพาะ",
  "selfTrainingStatus": "อบรมเอง",
  "sendApproval": "ส่งขออนุมัติ",
  "sendApprovalItems": "ส่งขออนุมัติ",
  "serviceGroup": "กลุ่มงานสัญญา",
  "socialSecurity": "เอกสารประกันสังคม",
  "specialWorkInfo": "ข้อมูลหน้าที่เฉพาะ",
  "specialWorkType": "ประเภท",
  "specifyExp": "ถ้าเคย โปรดระบุจำนวนปี",
  "startDate": "วันเริ่มต้นสัญญา",
  "status": "สถานะ",
  "statusExamDriverLicense": "สถานะการสอบ",
  "statusExamFireWatch": "สถานะการสอบ",
  "stickerApproval": "การอนุมัติหน้าที่เฉพาะ : {$INTERPOLATION}",
  "subContractor": "ผู้รับเหมารายย่อย",
  "summaryRequestCard": "สรุปยอดการขอทำบัตรทั้งหมด",
  "telNumber": "เบอร์โทรศัพท์",
  "titleEN": "คำนำหน้า (อังกฤษ)",
  "titleTH": "คำนำหน้า (ไทย)",
  "toDateOfTraining": "วันที่สิ้นสุดการอบรม (ถึง)",
  "topGroupDriverLicense": "TOP Group Driver License",
  "totalContractorCard": "จำนวนบัตรทั้งหมด",
  "trainTheTrainerApplicationFormAttachment": "เอกสารแบบฟอร์มขออบรมหลักสูตร Train the trainer ",
  "training": "อบรม",
  "trainingDate": "วันที่ได้รับอบรม",
  "trainingDateFrom": "วันที่เริ่มต้นการอบรม",
  "trainingDateTo": "วันที่สิ้นสุดการอบรม (ถึง)",
  "trainingInstitute": "หน่วยงาน/สถาบันฝึกอบรม",
  "trainingStatus": "กำลังอบรม",
  "transcriptOfEducationAttachment": "เอกสารรับรองการศึกษา",
  "unFitToWork": "ปฏิบัติงานไม่ได้",
  "university": "มหาวิทยาลัย/วิทยาลัย",
  "userGuideForAdmin": " คู่มือการใช้งานสำหรับ Admin ",
  "userGuideForContractor": " คู่มือการใช้งาน ",
  "userGuideForTOP": " คู่มือการใช้งาน ",
  "validateCertificateContractor": "โปรดระบุเอกสารรับรองการปฏิบัติงานจากบริษัทผู้รับเหมา",
  "validateForkliftDriverCertificateFiles": "โปรดระบุเอกสารรับรองการอบรม",
  "validateForkliftDriverFormFiles": "โปรดระบุเอกสารขออนุญาตขับรถ",
  "validatePosition": "โปรดระบุตำแหน่งหน้าที่ปฏิบัติ",
  "validateSafetyAuthorizer": "โปรดระบุหลักสูตร",
  "validateTrainingFiles": "โปรดระบุเอกสารรับรองการอบรม",
  "validateWorkHistoryFiles": "โปรดระบุเอกสารประวัติการทำงาน",
  "van": "รถตู้",
  "verificationProcess": "กำลังตรวจสอบ",
  "vocationalCertificate": "ปวช.",
  "vocationalDiploma": "ปวส.",
  "waitingForAE": "รอ AE",
  "waitingForAGSI": "รอ AGSI",
  "waitingForAnnouncement": "รอ Announcement",
  "waitingForAppoint": "รอ Appoint",
  "waitingForApproval": "รออนุมัติ",
  "waitingForApprovalBySectionHead": "รออนุมัติโดย Section Head",
  "waitingForApprovalRequest": "รอการอนุมัติคำขอ",
  "waitingForBuyer": "รอ Buyer",
  "waitingForCustodian": "รอ Custodian",
  "waitingForDocument": "รอตรวจเอกสาร",
  "waitingForInterview": "รอสัมภาษณ์",
  "waitingForIssuingCard": "รอการออกบัตร",
  "waitingForPerson": "รอ PM/SH",
  "waitingForPrint": "รอพิมพ์บัตร",
  "waitingForPrintSticker": "รอพิมพ์สติกเกอร์",
  "waitingForSafety": "รอ Safety",
  "waitingForSectionHead": "รอ SectionHead",
  "waitingForSecurity": "รอ Security",
  "waitingForTraining": "รออบรม",
  "waitingForTrainingProcess": "รอการอบรม",
  "waitingForTrainingStatus": "รออบรม",
  "waitingForexamStatus": "รอผล",
  "warningTitle": "กรุณาตรวจสอบ",
  "whenDidYouSucceedFlagmanTraining": "วันที่ผ่านการอบรม Flagman ครั้งล่าสุด",
  "whenDidYouSucceedHighPressureWaterJetTraining": "คุณผ่านการอบรม High Pressure Water Jet ครั้งล่าสุดเมื่อไหร่",
  "whenSucceededFireWatchTraining": "วันที่ผ่านการอบรม Fire watch man ครั้งล่าสุด",
  "workAtHeight(21M.)": "ผู้ปฎิบัติงานบนที่สูง (21 เมตรขึ้นไป)",
  "workAtHeightCertificateAttachment": "เอกสารรับรองการอบรม (ถ้ามี)",
  "workAtHeightCitizenCardAttachment": "บัตรพนักงาน, บัตรประชาชน",
  "workHistoryFiles": "เอกสารประวัติการทำงาน",
  "workInConfinedSpace": "การทำงานในพื้นที่อับอากาศ",
  "workInCrane": "งานเกี่ยวกับปั้นจั่น",
  "workInCraneCertificateAttachment": "เอกสารรับรองการอบรม",
  "workInSafety": "เจ้าหน้าที่ความปลอดภัยในการทำงาน",
  "workPermit": "สำเนาใบอนุญาตทำงาน",
  "workPositions": "ตำแหน่งหน้าที่ปฏิบัติงาน",
  "workRisk": "ความเสี่ยงของงาน",
  "workType": "ประเภทงาน",
  "workerInfo": "ข้อมูลผู้ปฏิบัติงาน",
  "workerList": "รายการผู้ปฏิบัติงาน",
  "workerNo": "เลขที่ผู้ปฏิบัติงาน",
  "yearForGraduated": "ปีการศึกษาที่จบ",
  "yes": "ใช่"
}